import React from 'react';
import InvoiceDraftDetail from '../modules/invoices/components/InvoiceDraftDetail';
export default function SalesInvoiceDraftDetail() { return <InvoiceDraftDetail direction="SALES" />; }
